import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { deliveryTypeStore } from '../../store/deliveryTypeStore';
import BranchWorkingTime from '../BranchWorkingTime/BranchWorkingTime';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { localeStore } from 'src/mobx/localesStore';
import { IBranch } from 'src/types/branches';
import { getTranslate, hasBranch } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

const MapDeliveryBranch: React.FC = observer((): JSX.Element => {
  const branch = useMemo((): IBranch | undefined => {
    return deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].branch;
  }, [deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].branch]);

  const wrapperClassName = useMemo((): string => {
    let className: string = 'map-delivery-branch__title';

    if (!hasBranch(branch?.id)) className += ' color-gray3';

    return className;
  }, [branch]);

  if (!branch?.id && !deliveryTypeStore.loading) {
    return (
      <div className="d-flex map-delivery-branch">
        {/* this language key, this is not a mistake */}
        <p className="family-semibold text-size-18">{localeStore.t('Your delivery address is not covered by any branch anymore')}</p>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column map-delivery-branch">
      <span className={wrapperClassName}>{branch ? getTranslate(branch?.name) : <Skeleton width={100} />}</span>
      <div className="d-flex flex-1 flex-column">
        <div className="d-flex align-items-baseline full-width justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <Icon name={Icons.Clock} size={24} className="color-gray2 mr-2" />
            <div className="d-flex flex-column ">
              <span className="family-medium text-size-14">{branch?.working_hours || <Skeleton width={100} />}</span>
            </div>
          </div>
          {branch ? <BranchWorkingTime vertical="top" branch={branch} /> : null}
        </div>
        <div className="d-flex align-items-center full-width justify-content-between">
          <div className="d-flex align-items-center">
            <Icon name={Icons.Geo} size={24} className="color-gray2 mr-2" />
            <div className="d-flex flex-column ">
              <span className="family-medium text-size-14">{branch ? branch?.address : <Skeleton width={100} />}</span>
            </div>
          </div>
          {branch?.distance ? (
            <span className="family-medium text-size-12 text-nowrap color-gray3 text-uppercase ml-2 mt-2">{branch?.distance}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
});

export default MapDeliveryBranch;
